import { jsx as _jsx } from "react/jsx-runtime";
import { buildElementsTree } from '@lucidlink/uicore';
export const getRouteObject = ({ handle, lazy, path, wrappers, }) => {
    return {
        ...(handle ? { handle } : {}),
        lazy: async () => {
            const lazyPromise = typeof lazy === 'function' ? lazy() : lazy;
            const Component = (await lazyPromise).default;
            return {
                element: buildElementsTree(wrappers, _jsx(Component, {})),
            };
        },
        path,
    };
};
